<template>
  <div class="sprint-module">
    <div class="k-sprint" :style="aStyle">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="btn-item"
        :style="{
          width: $unit(item.btnWidth),
          left: $unit(item.btnLeft),
          bottom: $unit(item.btnBottom)
        }"
        @click="startTurns(index)"
      >
        <img
          :src="btnStatus(index).imgPath"
          class="btn"
          :class="{ gray: btnStatus(index).style.gray }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
const muduleBgHeight = 470;
export default {
  name: 'McSprint',
  props: {
    draw: {
      type: Object,
      default: () => {}
    },
    view: {
      type: Object,
      default: () => {}
    },
    list: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      height: muduleBgHeight,
      defaultModuleBg:
        '//cdn-tx-admin-test.3kwan.com/2023/07/26/5589be523b081a5de28cd32a773890ac.jpg',
      defaultGetBtn:
        '//cdn-tx-admin-test.3kwan.com/2023/07/26/91170f92111f11e94926fc52e1a37e58.png',
      lock: false
    };
  },
  components: {},
  computed: {
    state() {
      return this.$store.state;
    },
    receivePrize() {
      return this.view?.ext_params?.receive_prize || '';
    },
    prizeList() {
      return this.list.reduce((prev, cur) => {
        prev.push({
          ...cur,
          receive_prize: this.receivePrize[cur.prize_id]
        });
        return prev;
      }, []);
    },
    ...mapGetters(['prize']),
    aStyle() {
      return {
        height: this.$unit(this.height),
        backgroundImage: `url(${this.draw.bg || this.defaultModuleBg})`
      };
    }
  },
  watch: {
    draw() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.height = h;
      };
      img.onerror = () => {
        this.height = muduleBgHeight;
      };
      img.src = this.draw.bg;
    },
    btnStatus(i) {
      var imgPath = this.defaultGetBtn;
      var style = { isGray: false };
      if (this.viewStatus != 2 && this.draw.btn != '') {
        imgPath = this.draw.btn;
      } else {
        let curPrize = this.prizeList[i];
        let curPrizeStatus = curPrize.receive_prize;
        switch (curPrizeStatus) {
          case 1:
            //已领取
            imgPath = this.draw.lookBtn;
            break;
          case 2:
            imgPath = this.draw.btn;
            //可领取
            break;
          case 3:
            //不可领取
            imgPath = this.draw.btn;
            style.gray = true;
            break;
        }
      }
      return { imgPath, style };
    },
    startTurns(index) {
      if (this.viewStatus != 2) return;
      if (this.state.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
        return false;
      }
      if (!this.canBeRotated()) {
        return false;
      }
      this.lock = true;
      let curPrize = this.prizeList[index];
      let curPrizeStatus = curPrize.receive_prize;
      if (curPrizeStatus == 1) {
        //查看奖励
        this.$store.commit('UPDATE_MODULE_ID', this.moduleId);
        this.$store.commit('OPEN_DIALOG', 'PrizeRecord');
        this.lock = false;
        return false;
      }
      this.drawPrize(index);
    },
    //请求服务端抽奖
    async drawPrize(index) {
      let { code, data } = await this.$api.prize.receivePrize({
        module_id: this.moduleId,
        guid: this.state.userInfo.guid,
        server_id: this.state.userInfo.server_id,
        role_id: this.state.userInfo.role_id,
        prize_id: this.list[index].prize_id
      });
      if (code !== 0) {
        this.lock = false;
        return;
      }
      this.Track(5, this.moduleId);
      this.$store.commit('UPDATE_PRIZE', data);
      this.endTurns();
    },
    endTurns() {
      // 中奖
      this.$store.commit('OPEN_DIALOG', 'Prize');
      // 解锁
      this.lock = false;
      this.$store.dispatch('INIT_ACTIVITY');
    },
    canBeRotated() {
      if (this.lock) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.k-sprint {
  position: relative;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  z-index: 499;
}
.btn-item {
  position: absolute;
  z-index: 499;
  .btn {
    display: block;
    width: 100%;
  }
  .gray {
    filter: grayscale(100%);
  }
}
</style>
